import { bootstrap } from "@ms-fabric/workload-client";
import "./i18n";

function printFormattedAADErrorMessage(hashMessage: string): void {
  const hashString = hashMessage.slice(1);

  // Decode URL encoding and parse key-value pairs
  const searchParams = new URLSearchParams(hashString);
  const formattedMessage: Record<string, string> = {};

  searchParams?.forEach((value, key) => {
    formattedMessage[key] = decodeURIComponent(value);
  });

  // Print formatted message
  document.documentElement.innerHTML =
    "There was a problem with the consent, open browser debug console for more details";
  for (const key in formattedMessage) {
    if (Object.prototype.hasOwnProperty.call(formattedMessage, key)) {
      console.log(`${key}: ${formattedMessage[key]}`);
    }
  }
}

/** This is used for authentication API as a redirect URI.
 * Delete this code if you do not plan on using authentication API.
 * You can change the redirectUriPath to whatever suits you.
 */
const redirectUriPath = "/close";
const url = new URL(window.location.href);
if (url.pathname?.startsWith(redirectUriPath)) {
  // Handle errors, Please refer to https://learn.microsoft.com/en-us/entra/identity-platform/reference-error-codes
  if (url?.hash?.includes("error")) {
    // Handle missing service principal error
    if (url.hash.includes("AADSTS650052")) {
      printFormattedAADErrorMessage(url?.hash);
      // handle user declined the consent error
    } else if (url.hash.includes("AADSTS65004")) {
      printFormattedAADErrorMessage(url?.hash);
    } else {
      window.close();
    }
  } else {
    // close the window in case there are no errors
    window.close();
  }
}

console.log("****Runtime: Environment Variables****");
console.log("process.env.WORKLOAD_NAME: " + process.env.WORKLOAD_NAME);
console.log("process.env.WORKLOAD_BE_URL: " + process.env.WORKLOAD_BE_URL);
console.log("**************************************");

function getUrlErrors(): { error?: string; description?: string } | null {
    const url = new URL(window.location.href);

    // Check hash (#error=...)
    const hashParams = new URLSearchParams(url.hash.slice(1));

    // Check query (?error=...)
    const queryParams = new URLSearchParams(url.search);

    const error =
        hashParams.get("error") || queryParams.get("error");

    const description =
        hashParams.get("error_description") ||
        queryParams.get("error_description");

    if (!error && !description) return null;

    return { error, description };
}

function showErrorUI(title: string, message: string) {
    const container = document.createElement("div");

    container.innerHTML = `
              <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;  font-family: Segoe UI, sans-serif; padding: 20px; text-align: center;">
                <h2 style="color:#ff4d4f;">${title}</h2>
                <p>${message}</p>
              </div>
    `;

    document.body.appendChild(container);
}

const urlError = getUrlErrors();

if (urlError) {
    console.error("URL Error:", urlError);

    showErrorUI(
        "Authentication Error",
        urlError.description || urlError.error || "Unknown error"
    );
}

function handleRuntimeError(error: unknown) {
    console.error("Runtime Error:", error);

    // const message =
    //     error instanceof Error
    //         ? error.message
    //         : String(error);

    // showErrorUI(
    //     "Application Runtime Error",
    //     message
    // );
}

window.addEventListener("error", e =>
    handleRuntimeError(e.error || e.message)
);

window.addEventListener("unhandledrejection", e =>
    handleRuntimeError(e.reason)
);


// function showGlobalError(error: unknown) {
//   console.error("🚨 Runtime Error:", error);

//   document.documentElement.innerHTML = `
//         <div style="
//             font-family: Segoe UI, sans-serif;
//             padding: 40px;
//             text-align: center;
//         ">
            
//             <p>you are tring to access the workload outside the fabric enviroment.</p>
//         </div>
//     `;
// }

// window.addEventListener("error", (event) => {
//   showGlobalError(event.error || event.message);
// });

// window.addEventListener("unhandledrejection", (event) => {
//   showGlobalError(event.reason);
// });

// bootstrap({
//   initializeWorker: (params) =>
//     import("./index.worker").then(({ initialize }) => initialize(params)),
//   initializeUI: (params) =>
//     import("./index.ui").then(({ initialize }) => initialize(params)),
// });

// async function safeBootstrap() {
//     try {
//         await bootstrap({
//             initializeWorker: async (params) => {
//                 const { initialize } = await import('./index.worker');
//                 return initialize(params);
//             },
//             initializeUI: async (params) => {
//                 const { initialize } = await import('./index.ui');
//                 return initialize(params);
//             },
//         });
//     } catch (error) {
//         showGlobalError(error);
//     }
// }

async function safeBootstrap() {
    try {
        await bootstrap({
            initializeWorker: async params => {
                const { initialize } = await import("./index.worker");
                return initialize(params);
            },
            initializeUI: async params => {
                const { initialize } = await import("./index.ui");
                return initialize(params);
            }
        });
    } catch (err) {
        handleRuntimeError(err);
    }
}

safeBootstrap();
